export default __webpack_public_path__ + "static/media/foto-tratamento-onco.d794a7cb.png";